module.exports = __webpack_public_path__ + "fonts/ralewayextrabolditalic.f7e3df4.woff2";